import { apiSlice } from "../api/apiSlice";

export const quizzesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizzes: builder.query({
            query: () => `/quizzes`,
        }),

        getQuiz: builder.query({
            query: (id) => `/quizzes?id=${id}`,
        }),
        
        getQuizByVideo: builder.query({
            query: (videoId) => `/quizzes?video_id=${videoId}`,
        }),

        addQuiz: builder.mutation({
            query: (data) => ({
                url: "/quizzes",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getQuizzes", undefined, draft => {
                                draft.push(res?.data)
                            })
                        )
                    }
                } catch (err) {

                }
            },
        }),

        editQuiz: builder.mutation({
            query: ({ id, data }) => ({
                url: `/quizzes/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getQuizzes", undefined, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );

                        dispatch(
                            apiSlice.util.updateQueryData("getQuiz", arg.id, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = res?.data;
                            })
                        );


                    }
                } catch (err) {

                }
            },
        }),

        deleteQuiz: builder.mutation({
            query: (id) => ({
                url: `/quizzes/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
                            return draft.filter(a => a.id != arg)
                        })
                    )
                } catch (err) {

                }
            },
        }),
    }),
});

export const {
    useGetQuizQuery,
    useGetQuizzesQuery,
    useAddQuizMutation,
    useEditQuizMutation,
    useDeleteQuizMutation,
    useGetQuizByVideoQuery
} = quizzesApi;
